export default {
    SET_PROJECT_LIST(state, items) {
        state.projects = items;
    },
    SET_SEARCH_QUERY(state, query) {
        state.searchQuery = query;
    },
    ADD_FAVORITE_SITE(state, item) {
        state.favorites.push(item);
    },
    REMOVE_FAVORITE_SITE(state, item) {
        const ItemIndex = state.favorites.findIndex((p) => p.ProjectID == item.ProjectID)
        state.favorites.splice(ItemIndex, 1)
    },
}